// Characters that spreadsheet software (Excel, Numbers, Calc) interprets as formula prefixes.
// See https://owasp.org/www-community/attacks/CSV_Injection
const SPREADSHEET_INJECTION_PREFIXES = ['=', '+', '-', '@', '\t', '\r', '🟰', '＝', '＋', '－', '＠'];

function _needsSpreadsheetInjectionSanitization(s: string): boolean {
  if (s.trim() !== '' && Number.isFinite(Number(s.trim()))) {
    // CSV tools expecting numbers in cells can break when sanitization is applied, so avoid sanitizing cells
    // containing numbers. For example, `-10` would be sanitized to `'-10` if not for this check.
    return false;
  }
  return SPREADSHEET_INJECTION_PREFIXES.some((prefix) => s.startsWith(prefix));
}

function _formatCellForDelimiter(s: string, d: string): string {
  const shouldSanitizeSpreadsheetInjection = _needsSpreadsheetInjectionSanitization(s);
  if (shouldSanitizeSpreadsheetInjection) {
    s = `'${s}`;
  }
  switch (d) {
    case '\t':
      return s.replace(/\t/g, ' ');
    case ',': {
      // CSV injection-safe values are always quoted so spreadsheet software preserves the leading quote.
      if (shouldSanitizeSpreadsheetInjection || /[",\n\r]/.test(s)) {
        s = s.replace(/"/g, '""');
        return `"${s}"`;
      }

      return s;
    }
    default:
      return s;
  }
}

function _formatRow(row: Array<string>, delimiter: string): string {
  return row.map((cell) => _formatCellForDelimiter(cell, delimiter)).join(delimiter);
}

export function formatRows(rows: Array<Array<string>>, delimiter: string): string {
  let result = rows.map((row) => _formatRow(row, delimiter)).join('\n');
  result += '\n';
  return result;
}
